const modules = import.meta.glob('../assets/**/*', { eager: true, query: '?url', import: 'default' })

const map = {}
for (const [key, url] of Object.entries(modules)) {
  const rel = key.replace(/^.*\/assets\//, '')
  map[rel] = url
}

export function asset(rel) {
  return map[rel]
}

export default asset
